import { AssessmentKeys } from '@uplift/types';
import { restClient } from '../../client';

export type FormKeyOutput = {
  [id in AssessmentKeys]: string;
};

export const getAssessmentFormKeys = () => restClient.rawRequest<FormKeyOutput>('/api/v1/form/assessments');

export type FormNameOutput = {
  data: Record<string, string>;
};

export const getFormNames = (ids: string[]) =>
  restClient.request<FormNameOutput>('/api/v1/form/names', {
    method: 'POST',
    data: {
      form_ids: ids
    }
  });


export const getFormKeysByFormId = () => restClient.rawRequest<{
  data: Record<string, string>;
}>('/api/v1/form/keys');
